import type { TFunction } from 'i18next';

import type { CreativesCopy } from './creatives-summary';

/**
 * The Website Creatives card's copy: one literal `t()` key per id, so the extractor harvests every one; the `switch`
 * is exhaustive, so a new id fails the typecheck until it has its copy.
 */
export const creativesCopy = (t: TFunction, c: CreativesCopy): string => {
  switch (c.id) {
    case 'new-banners':
      return t('New banners from Lumio');
    case 'carousels-to-publish':
      return c.n === 1 ? t('1 carousel to publish') : t('{{n}} carousels to publish', { n: c.n });
    case 'generating':
      return t('Generating');
    case 'banners-all-published':
      return c.n === 1
        ? t('1 banner, all carousels published')
        : t('{{n}} banners, all carousels published', { n: c.n });
    case 'banners':
      return c.n === 1 ? t('1 banner') : t('{{n}} banners', { n: c.n });
    case 'preparing-banners':
      return t('Lumio is preparing your banners');
    case 'no-banners':
      return t('No banners yet');
    case 'see-new-banners':
      return t('See new banners');
    case 'edit-carousels':
      return t('Edit carousels');
    case 'open-banners':
      return t('Open banners');
  }
};
